module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-modal modal fade noselect",
    attrs: {
      "id": "modalTransfertAbsencesFutures"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.valider($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "tw-py-2 tw-pr-2"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Attention,")]), _vm._v(" ce salarié possède des absences validées ou en attente de validation rattachées à un ancien contrat :\n\n                                "), _c('div', {
    staticClass: "m-3"
  }, _vm._l((_vm.listeAbsences), function(conge) {
    return _c('div', {
      staticClass: "ml-5"
    }, [_vm._v("\n                                        " + _vm._s(conge.LibelleTypeAbsence) + " du " + _vm._s(_vm._f("moment")(conge.DateDebut, "DD/MM/YY")) + " au " + _vm._s(_vm._f("moment")(conge.DateFin, "DD/MM/YY")) + "\n                                    ")])
  })), _vm._v("\n\n                                Souhaitez vous rattacher ces absences au nouveau contrat ?\n                                (En refusant, ces absences seront annulées)\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer tw-mt-5 tw-pr-0"
  }, [_c('div', {
    staticClass: "area-action"
  }, [_vm._m(2), _vm._v(" "), _c('button', {
    staticClass: "inp-button-modal cancel ml-1",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Non")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Attention ! ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_c('span', {
    staticClass: "fas fa-exclamation-triangle fa-3x",
    staticStyle: {
      "opacity": "0.5",
      "color": "red"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "inp-button-modal valid",
    attrs: {
      "type": "submit"
    }
  }, [_c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-check"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Oui")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e25ca86"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modalComponents/modalTransfertAbsencesFutures/modalTransfertAbsencesFutures.vue.html
// module id = trrr
// module chunks = 2